import React, { useCallback, useContext } from 'react';
import cn from 'classnames';
import { Button, ButtonProps, Select, IconGlobe } from '@wheely/ui-kit';

import { IntlContext } from '../../../../src/i18n';
import { TLanguageTag } from '../../../../src/services/userLanguage';

import s from './style.module.css';

type LanguageItem = { title: string; value: TLanguageTag };
type HandleItemSelect = (item: LanguageItem) => void;

type Props = {
  className?: string;
  buttonProps?: ButtonProps;
};

const LANGUAGE_ITEMS: LanguageItem[] = [
  {
    value: 'en',
    title: 'English',
  },
  {
    value: 'ru',
    title: 'Русский',
  },
  {
    value: 'fr',
    title: 'Français',
  },
];

const LanguageSwitcher: React.VFC<Props> = ({
  buttonProps: { className: buttonClassname, ...restButtonProps } = {},
  ...restProps
}) => {
  const { language, setLanguage } = useContext(IntlContext);

  const handleItemSelect = useCallback<HandleItemSelect>(
    item => {
      setLanguage(item.value);
    },
    [setLanguage],
  );

  const selectedItem = LANGUAGE_ITEMS.find(({ value }) => value === language) || LANGUAGE_ITEMS[0];

  return (
    <Select
      selectedItem={selectedItem}
      items={LANGUAGE_ITEMS}
      onItemSelect={handleItemSelect}
      popoverProps={{
        minimal: true,
      }}
      popoverTargetProps={{ className: s.popoverTarget }}
      {...restProps}
    >
      <Button
        minimal={true}
        icon={<IconGlobe />}
        text={selectedItem.title}
        className={cn(s.button, buttonClassname)}
        data-test-id="language-switcher__button"
        {...restButtonProps}
      />
    </Select>
  );
};

export { LanguageSwitcher };
